function isVisibleGuideButton(button) {
  if (!button) return false;

  const style = window.getComputedStyle(button);
  if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
    return false;
  }

  const rect = button.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function isElementVisible(element) {
  if (!element) return false;

  const style = window.getComputedStyle(element);
  if (style.display === 'none' || style.visibility === 'hidden') {
    return false;
  }

  return element.getClientRects().length > 0;
}

const SIZE_LABEL_SELECTORS = [
  '.name-option[data-name="Talla"]',
  '.name-option[data-name="Size"]',
  '.name-option[data-name="Tamaño"]',
  '.name-option[data-name="Taille"]',
  '.name-option[data-name="Größe"]',
  '.name-option[data-name="Tamanho"]',
  '.name-option[data-name="talla"]',
  '.name-option[data-name="size"]',
  '.name-option[data-name="tamaño"]',
  '.name-option[data-name="taille"]',
  '.name-option[data-name="größe"]',
  '.name-option[data-name="tamanho"]',
];

function getSearchRoots(wrap) {
  const roots = new Set([wrap]);
  const form = wrap.closest('.product-form, product-form-component, form');
  if (form) roots.add(form);
  return [...roots];
}

function findGloboSizeLabel(wrap) {
  for (const root of getSearchRoots(wrap)) {
    for (const selector of SIZE_LABEL_SELECTORS) {
      const label = root.querySelector(selector);
      if (label) return label;
    }

    const fallback = [...root.querySelectorAll('.name-option, legend.name-option')].find((label) => {
      const dataName = (label.getAttribute('data-name') || '').toLowerCase();
      if (
        dataName.includes('talla') ||
        dataName.includes('tamaño') ||
        dataName.includes('tamano') ||
        dataName === 'size' ||
        dataName.includes('taille') ||
        dataName.includes('größe') ||
        dataName.includes('grosse') ||
        dataName.includes('tamanho')
      ) {
        return true;
      }

      const text = label.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      return (
        text.startsWith('talla') ||
        text.startsWith('tamaño') ||
        text.startsWith('tamano') ||
        text.startsWith('size') ||
        text.startsWith('taille') ||
        text.startsWith('größe') ||
        text.startsWith('grosse') ||
        text.startsWith('tamanho')
      );
    });

    if (fallback) return fallback;
  }

  return null;
}

function getFixedRow(wrap) {
  return wrap.querySelector('.product-size-guide-row--fixed');
}

function getFixedRowOpener(wrap) {
  return getFixedRow(wrap)?.querySelector('.product-size-guide__opener') || null;
}

function getInlineGuideButton(wrap) {
  const selectors = [
    '.form__label--with-size-guide .product-size-guide__button',
    '.name-option .product-size-guide__button',
    '.globo-swatch-product-detail .product-size-guide__button',
  ];

  for (const selector of selectors) {
    for (const root of getSearchRoots(wrap)) {
      const button = root.querySelector(selector);
      if (button) return button;
    }
  }

  return null;
}

function injectGloboSizeGuide(wrap) {
  const label = findGloboSizeLabel(wrap);
  if (!label || label.querySelector('.product-size-guide__opener')) {
    return Boolean(label && label.querySelector('.product-size-guide__opener'));
  }

  const opener = getFixedRowOpener(wrap);
  if (!opener) return false;

  label.classList.add('form__label--with-size-guide');
  label.appendChild(opener);
  return true;
}

function restoreFixedRowOpener(wrap) {
  const fixedRow = getFixedRow(wrap);
  const opener = getFixedRowOpener(wrap);
  if (!fixedRow || opener) return;

  if (findGloboSizeLabel(wrap)?.querySelector('.product-size-guide__opener')) return;

  const nativeOpener = wrap.querySelector('variant-selects .product-size-guide__opener');
  if (nativeOpener) return;

  for (const root of getSearchRoots(wrap)) {
    const strayOpener = root.querySelector('.product-size-guide__opener');
    if (strayOpener) {
      fixedRow.appendChild(strayOpener);
      break;
    }
  }
}

function syncProductSizeGuides() {
  document.querySelectorAll('.product-variant-picker-wrap').forEach((wrap) => {
    injectGloboSizeGuide(wrap);

    const fixedRow = getFixedRow(wrap);
    if (!fixedRow) return;

    const inlineButton = getInlineGuideButton(wrap);

    if (isVisibleGuideButton(inlineButton)) {
      fixedRow.hidden = true;
      return;
    }

    if (inlineButton) {
      fixedRow.hidden = true;
      return;
    }

    restoreFixedRowOpener(wrap);
    fixedRow.hidden = !getFixedRowOpener(wrap);
  });
}

function observeProductSizeGuideWraps() {
  document.querySelectorAll('.product-variant-picker-wrap').forEach((wrap) => {
    if (wrap.dataset.sizeGuideObserved === 'true') return;
    wrap.dataset.sizeGuideObserved = 'true';

    const observer = new MutationObserver(() => {
      syncProductSizeGuides();
    });

    observer.observe(wrap, { childList: true, subtree: true });

    const form = wrap.closest('.product-form, product-form-component, form');
    if (form && form !== wrap && form.dataset.sizeGuideObserved !== 'true') {
      form.dataset.sizeGuideObserved = 'true';
      const formObserver = new MutationObserver(() => {
        syncProductSizeGuides();
      });
      formObserver.observe(form, { childList: true, subtree: true });
    }
  });
}

function initProductSizeGuides() {
  observeProductSizeGuideWraps();
  syncProductSizeGuides();
}

document.addEventListener('DOMContentLoaded', initProductSizeGuides);
document.addEventListener('shopify:section:load', initProductSizeGuides);
window.addEventListener('resize', syncProductSizeGuides);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, () => {
    requestAnimationFrame(initProductSizeGuides);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductSizeGuides);
} else {
  initProductSizeGuides();
}
